// TODO(david)[ENG-124]: Import these from the atoms library instead of duplicating.
const pdfColors = {
  // Background
  bgPrimary: '0 0% 100%', // #FFFFFF
  bgSecondary: '0 0% 98%', // #FAFAFA
  bgTertiary: '0 0% 96%', // #F5F5F5
  bgQuaternary: '0 0% 94%', // #F0F0F0
  bgStrong: '0 0% 9%', // #171717
  // Border
  borderPrimary: '0 0% 94%', // #F0F0F0
  borderSecondary: '0 0% 87%', // #DEDEDE
  borderTertiary: '0 0% 76%', // #C2C2C2
  borderQuaternary: '0 0% 76%', // #C2C2C2
  // Text
  textPrimary: '0 0% 22%', // #383838
  textSecondary: '0 0% 30%', // #4D4D4D
  textTertiary: '0 0% 45%', // #737373
  textSupporting: '0 0% 57%', // #919191
  textDisabled: '0 0% 76%', // #C2C2C2
  textStrong: '0 0% 96%', // #F5F5F5
};

const config = {
  theme: {
    fontFamily: {
      sans: ['Inter'],
    },
    extend: {
      colors: Object.fromEntries(
        Object.entries(pdfColors).map(([key, value]) => [key, `hsl(${value})`]),
      ),

      // NOTE: react-pdf-tailwind uses a base rem value of 12pt (12px) instead of the standard 16pt (16px).
      // This means all font sizes are 75% of what they would be with a standard 16pt base because we use
      // the same rem values for the font sizes as we do in libs/frontend/components/src/lib/TextStyles.tsx.
      // For example: 1rem = 12px (not 16px), 2rem = 24px (not 32px), etc.
      fontSize: {
        // Heading sizes
        'heading-3xl': [
          '2.25rem',
          {
            // 27px - 36px
            // react-pdf-tailwind doesn't support unit values for line heights,
            // only a number value that is used as a multiplier of the font size
            lineHeight: 1.33,
          },
        ],
        'heading-2xl': [
          '2.0rem',
          {
            // 24px - 31px
            lineHeight: 1.31,
          },
        ],
        'heading-xl': [
          '1.75rem',
          {
            // 21px - 27px
            lineHeight: 1.29,
          },
        ],
        'heading-lg': [
          '1.5rem',
          {
            // 18px - 24px
            lineHeight: 1.33,
          },
        ],
        'heading-md': [
          '1.25rem',
          {
            // 15px - 20px
            lineHeight: 1.3,
          },
        ],
        'heading-sm': [
          '1.125rem',
          {
            // 13.5px - 18px
            lineHeight: 1.33,
          },
        ],

        // Body sizes
        'body-lg': [
          '1.0rem',
          {
            // 12px - 18px
            lineHeight: 1.5,
          },
        ],
        'body-md': [
          '0.875rem',
          {
            // 10.5px - 15px
            lineHeight: 1.43,
          },
        ],
        'body-sm': [
          '0.75rem',
          {
            // 9px - 13.5px
            lineHeight: 1.5,
          },
        ],

        // Caption sizes
        'caption-md': [
          '0.6875rem',
          {
            // 8.25px - 12px
            lineHeight: 1.45,
          },
        ],
        'caption-sm': [
          '0.625rem',
          {
            // 7.5px - 10.5px
            lineHeight: 1.4,
          },
        ],
      },
    },
  },
};

export default config;
